import { Checkbox as InternalCheckbox } from "./Checkbox";
import Group from "antd/lib/checkbox/Group";
const Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.__ANT_CHECKBOX = true;
if (process.env.NODE_ENV !== "production") {
    Checkbox.displayName = "Checkbox";
}
export { Checkbox };
